import { Box, Grid, TextField, Typography, Chip } from "@mui/material";

const HotelView = ({ hotel }) => {
  if (!hotel) return null;
  const isActive = hotel.isActive !== false;

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} p={1.5} bgcolor={isActive ? "#f0fdf4" : "#f1f5f9"} borderRadius={1.5} border={`1px solid ${isActive ? "#bbf7d0" : "#e2e8f0"}`}>
        <Typography variant="subtitle2" fontWeight={600} color={isActive ? "success.dark" : "text.secondary"}>
          Status: {isActive ? "Active" : "Inactive"}
        </Typography>
        <Chip
          label={isActive ? "Visible in Inquiry" : "Hidden from Inquiry"}
          color={isActive ? "success" : "default"}
          variant={isActive ? "filled" : "outlined"}
          sx={{ fontWeight: 600, fontSize: "0.75rem" }}
        />
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField fullWidth disabled label="Hotel Name" value={hotel.hotel_name} />
        </Grid>
        <Grid item xs={6}>
          <TextField fullWidth disabled label="Type" value={hotel.type} />
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={2}>
        <Grid item xs={6}>
          <TextField fullWidth disabled label="Destination" value={hotel.destination} />
        </Grid>
        <Grid item xs={6}>
          <TextField fullWidth disabled label="Sub Destination" value={hotel.sub_destination} />
        </Grid>
      </Grid>

      {/* Season Dates */}
      {hotel.season_dates && hotel.season_dates.length > 0 && (
        <Box mt={3}>
          <Typography fontWeight={600}>Season Dates</Typography>
          <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
            {hotel.season_dates.map((date, i) => (
              <Chip key={i} label={`${date.start} to ${date.end}`} color="primary" variant="outlined" />
            ))}
          </Box>
        </Box>
      )}

      {/* Categories */}
      {hotel.category?.map((cat, i) => (
        <Box key={i} sx={{ border: "1px solid #ddd", mt: 3, borderRadius: 2, p: 2 }}>
          <Typography fontWeight={600}>Room Category: {cat.room_cat}</Typography>

          <Grid container spacing={2} mt={1}>
            <Grid item xs={6}>
              <Typography fontWeight={600}>Season Price</Typography>

              {cat.season_price && Object.entries(cat.season_price).map(([key, value]) => (
                <Typography key={key}>
                  {key.replace(/_/g, " ").toUpperCase()}: ₹{value}
                </Typography>
              ))}
            </Grid>

            <Grid item xs={6}>
              <Typography fontWeight={600}>Off Season Price</Typography>

              {cat.off_season_price && Object.entries(cat.off_season_price).map(([key, value]) => (
                <Typography key={key}>
                  {key.replace(/_/g, " ").toUpperCase()}: ₹{value}
                </Typography>
              ))}
            </Grid>
          </Grid>
        </Box>
      ))}

      <TextField fullWidth disabled label="Rating" value={hotel.rating || ""} sx={{ mt: 3 }} />
      <TextField fullWidth disabled label="Address" value={hotel.address || ""} sx={{ mt: 2 }} />
      <TextField fullWidth disabled label="Hotel Link" value={hotel.hotel_link || ""} sx={{ mt: 2 }} />

      {/* Contacts */}
      {hotel.contacts && hotel.contacts.length > 0 && (
        <>
          <Typography fontWeight={600} mt={3}>Contacts</Typography>
          {hotel.contacts.map((c, i) => (
            <TextField key={i} fullWidth disabled value={c} sx={{ mt: 1 }} />
          ))}
        </>
      )}

      {/* Amenities */}
      {hotel.amenities && hotel.amenities.length > 0 && (
        <>
          <Typography fontWeight={600} mt={3}>Amenities</Typography>
          <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
            {hotel.amenities.map((a, i) => (
              <Chip key={i} label={a} />
            ))}
          </Box>
        </>
      )}

      {/* Notes */}
      {hotel.notes && hotel.notes.length > 0 && hotel.notes.some(n => n?.trim() !== "") && (
        <>
          <Typography fontWeight={600} mt={3}>Notes</Typography>
          {hotel.notes.map((n, i) => (
            <TextField key={i} fullWidth multiline disabled value={n} sx={{ mt: 1 }} />
          ))}
        </>
      )}
    </Box>
  );
};

export default HotelView;
